import { render, staticRenderFns } from "./DsInputTooltip.vue?vue&type=template&id=1ab8a991&"
import script from "./DsInputTooltip.vue?vue&type=script&lang=js&"
export * from "./DsInputTooltip.vue?vue&type=script&lang=js&"
import style0 from "./DsInputTooltip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports